import React, {useEffect, useRef, useState} from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CListGroup
} from "@coreui/react";
import DirectoryCard from "./DirectoryCard/DirectoryCard";
import {getDirectoriesRequest} from "../../services/api";
import {Link} from "react-router-dom";
import camelCaseItemNames from "camelcase-keys";
import {intervalRefObj} from "./Directories.model";
import {withErrorBoundary} from "../../components/ErrorBoundary";
import {useTranslation} from "react-i18next";
import {PATHS} from "../../route-dictionary";
import "./Directories.scss";

const Directories = () => {
  const [directoriesData, setDirectoriesData] = useState([]);
  const intervalRef = useRef({...intervalRefObj});

  const getDirectories = async () => {
    const directoriesResponse = await getDirectoriesRequest();
    setDirectoriesData(directoriesResponse.data.map((directory) => camelCaseItemNames(directory)));
    return directoriesResponse;
  };

  const updateDirectories = async () => {
    const directoriesResponse = await getDirectories();
    intervalRef.current.checkForClearInterval(directoriesResponse.data);
  };

  useEffect(() => {
    getDirectories();
    return intervalRef.current.clearDirectoriesInterval.bind(intervalRef.current);
  }, []);

  const {t} = useTranslation();

  return <CCard className="Directories">
    <CCardHeader>
      <h1 className="card-header-text">
        {t("page.directories", "Directories")}
      </h1>
    </CCardHeader>
    <CCardBody>
      <CCard>
        <CCardHeader className="d-flex flex-row Directories__directories-header">
          <h3 className="card-header-text">
            {t("card.title.directory.your", "Your user directories")}
          </h3>
          <CButton
            tag={Link}
            to={PATHS.DIRECTORIES.ADD}
            variant="outline"
            color="dark"
            className="Directories__add-button"
          >
            {t("button.addDirectory", "Add Directory")}
          </CButton>
        </CCardHeader>
        <CCardBody>
          <CListGroup accent className="Directories__list-group">
            {
              !directoriesData.length ?
                <p>{t("noData.directories", "No user directories are available")}</p>
                :
                directoriesData.map((item) =>
                  <DirectoryCard
                    intervalRef={intervalRef}
                    key={`${item.name}__${item.id}`}
                    onDeleteDirectorySuccess={getDirectories}
                    updateDirectories={updateDirectories}
                    directoryData={item}
                  />
                )
            }
          </CListGroup>
        </CCardBody>
      </CCard>
    </CCardBody>
  </CCard>;
};

export default withErrorBoundary(Directories);